



















import { Vue, Component, Prop } from 'vue-property-decorator'
import { LMap, LTileLayer, LMarker, LPolyline, LPopup, LControlAttribution } from 'vue2-leaflet'
import { LeafletMouseEvent } from 'leaflet'
import L from 'leaflet'
import 'mapbox-gl-leaflet'
import 'leaflet-polylinedecorator'
import Polylinedecorator from 'vue2-leaflet-polylinedecorator'
import { LatLngLocation } from '@/modules/absearch'
import {
  geoLocationIcon,
  StopIcon,
  DownIcon,
  miniStopIcon,
  UpIcon,
  AIcon,
  BIcon,
} from '@/components/icons'

const decoratorBuilder = function(offset: string, opacity: number) {
  return {
    offset,
    repeat: 150,
    symbol: L.Symbol.arrowHead({
      pixelSize: 6,
      polygon: false,
      pathOptions: {
        color: '#FFF',
        opacity,
        weight: 2,
      },
    }),
  }
}
const decoratorArrow1 = decoratorBuilder('42', 0.5)
const decoratorArrow2 = decoratorBuilder('50', 0.7)
const decoratorArrow3 = decoratorBuilder('58', 0.9)

@Component({
  components: {
    LMap,
    LMarker,
    LTileLayer,
    LPolyline,
    Polylinedecorator,
    LPopup,
    LControlAttribution,
  },
})
export default class Map extends Vue {
  public options = {
    zoomControl: false,
    attributionControl: false,
  }

  public disabledPolyStyle = {
    color: '#444',
    opacity: 0.5,
    weight: 5,
  }

  public geoMarkerOptions = {
    draggable: false,
    radius: 0,
    icon: geoLocationIcon,
    opacity: 0,
    fillOpacity: 0.2,
    fillColor: '#4285f4',
  }

  public backPolyStyle = {
    color: '#555',
    opacity: 0.75,
    weight: 10,
  }

  public polyStyle = {
    color: '#51B2E0',
    opacity: 0.9,
    weight: 8,
  }

  public patterns = [decoratorArrow1, decoratorArrow2, decoratorArrow3]

  public stopIcon = StopIcon
  public downIcon = DownIcon
  public miniStopIcon = miniStopIcon
  public upIcon = UpIcon
  public aOptions = {
    draggable: true,
    icon: AIcon,
    weight: 1,
    opacity: 0.7,
    fillOpacity: 0.25,
    color: '#FFB703',
  }
  public bOptions = {
    draggable: true,
    icon: BIcon,
    weight: 1,
    opacity: 0.3,
    fillOpacity: 0.15,
    color: '#B72815',
  }

  get center() {
    return L.latLng(this.$store.getters.getCiudadLatlng)
  }
  get zoom() {
    return this.$store.getters.getCiudadZoom
  }
  get recorridos() {
    return this.$store.getters.getRecorridosSearchBus
  }
  get recorridoSelectedIndex() {
    return this.$store.getters.getRecorridoSelectedIndexSearchBus
  }
  set recorridoSelectedIndex(val) {
    ;(this as any).$ga.event('resultados', 'select', '', val)
    this.$store.dispatch('setRecorridoSelectedIndexSearchBus', val)
  }
  get recorrido() {
    return this.$store.getters.getRecorridoSelectedSearchBus
  }
  get geolocation() {
    const coordinates: GeolocationCoordinates = this.$store.getters.geolocation
    if (coordinates === null) {
      return null
    }
    return {
      lat: coordinates.latitude,
      lng: coordinates.longitude,
      precision: coordinates.accuracy,
    }
  }
  public mounted() {
    (L as any).mapboxGL({
        style: 'https://tiles.cualbondi.org/api/maps/cualbondi/style.json',
        accessToken: 'no-token'
    }).addTo((this.$refs.mapref as any).mapObject);
  }
}
